export * from './authority-data-store'

import * as _selectors from './selectors';
export const authoritySelectors = _selectors;
